import { StatesModule } from '@uirouter/angular';
import { FiDocumentRootState } from './states/document-module-state';
import { FiDocumentListState } from './states/document-list-state';
import { FiDocumentCreateState } from './states/document-create-state';
import { FiDocumentCopyState } from './states/document-copy-state';
import { FiDocumentEditState } from './states/document-edit-state';
import { FiDocumentViewState } from './states/document-view-state';
import { FiDocumentVersionState } from './states/document-viersion.state';
import { FiDocumentRestoreState } from './states/document-restore-state';

export const FiDocumentStates: StatesModule = {
    states: [
        FiDocumentRootState,
        FiDocumentListState,
        FiDocumentCreateState,
        FiDocumentCopyState,
        FiDocumentEditState,
        FiDocumentViewState,
        FiDocumentVersionState,
        FiDocumentRestoreState,
    ],
};
